export default __webpack_public_path__ + "static/media/telefone.052e7b10.svg";